import axios from 'axios'
import Utils from '@/common/utils'

const headers = { Authorization: Utils.setCreditsManagerAppToken() }
export default class CreditsManagerService {
  static getURL (complement = '') {
    return `${process.env.VUE_APP_API_HOST}/credits${complement}`
  }

  static async getCreditInformation (params) {
    const url = this.getURL('/api-external/credits-by-client')
    const { data } = await axios.get(url, { headers, params })
    return data
  }

  static async getInterest (params) {
    const url = this.getURL('/api-external/credit-interest-earned')
    const { data } = await axios.post(url, params, { headers })
    return data
  }

  static async getFactoringDispersionsPdf (params) {
    const url = this.getURL(`/api-external/credit-line/${params.creditLineId}/dispersion-detail-base64`)
    const { data } = await axios.put(url, params.body, { headers })
    return data
  }

  static async getPortafolio (clientId) {
    const url = this.getURL(`/api-external/client/${clientId}/portafolio`)
    const { data } = await axios.get(url, { headers })
    return data?.data
  }

  static async getCredit (id) {
    const url = this.getURL(`/api-external/credit/${id}`)
    const { data } = await axios.get(url, { headers })
    return data
  }

  static async getCreditLine (id) {
    const url = this.getURL(`/api-external/credit-line/${id}`)
    const { data } = await axios.get(url, { headers })
    return data
  }

  static async getCreditAccountStatement (params) {
    const url = this.getURL(`/api-external/credit/${params.id}/base64`)
    const { data } = await axios.put(url, params, { headers })
    return data
  }

  static async getCreditLineAccountStatement (params) {
    const url = this.getURL(`/api-external/credit-line/${params.id}/base64`)
    const { data } = await axios.put(url, params, { headers })
    return data
  }

  static async getAmortizationSchedule ({ creditId, getOriginal = false }) {
    const url = this.getURL(`/api-external/credit/${creditId}/amortization-schedule`)

    const { data } = await axios.get(url, {
      headers,
      params: {
        original: getOriginal
      }
    })

    return data
  }

  static async getCreditBalance (params) {
    const url = this.getURL(`/api-external/credit/${params.id}/get-balance-at-day`)

    const { data } = await axios.put(url, params, { headers })

    return data
  }
}
